import { render, staticRenderFns } from "./MultiAttachment.vue?vue&type=template&id=a45fa182&scoped=true&"
import script from "./MultiAttachment.vue?vue&type=script&lang=js&"
export * from "./MultiAttachment.vue?vue&type=script&lang=js&"
import style0 from "./MultiAttachment.vue?vue&type=style&index=0&id=a45fa182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45fa182",
  null
  
)

export default component.exports